<div class="align-items-center flex justify-content-start">
<!--  <div class="col-2"></div>-->
<!--    <div class="col-2 viewBy-filter">
    <div class="field">
      <label>View By</label>
      <p-dropdown [(ngModel)]="selectPatientSubmissionOptions" [options]="patientSubmissionDropdown" (ngModelChange)="routeTo(selectPatientSubmissionOptions)"></p-dropdown>
    </div>
  </div>-->
  <div class="col-3">
    <div class="field">
      <ng-container>
        <label>Patient</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg"/></span>
          <input class="table-search-field w-full" type="text" [(ngModel)]="searchByPatient" [placeholder]="onlyAdminRoles() ? searchPatientById : searchPatientByNameOrMrn"
                 (keyup)="resetPageAndFetchEpisodes(searchByPatient)" (ngModelChange)="clearSearchAndReload(searchByPatient)"/>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="col-3" >
    <div class="field" >
      <ng-container>
        <label>Case Manager</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg" alt="search.svg"/></span>
          <input class="table-search-field w-full" type="text" [(ngModel)]="searchByCaseManager" [placeholder]="searchByCaseManagerPlaceHolder"
                 (keyup)="resetPageAndFetchEpisodes(searchByCaseManager)" (ngModelChange)="clearSearchAndReload(searchByCaseManager)"/>
        </div>
      </ng-container>
    </div>
  </div>
 <!-- <div class="col-3" >
    <div class="field" >
      <ng-container>
        <label>Clinician</label>
        <div class="p-inputgroup table-search-wrapper">
          <span class="p-inputgroup-addon"><img src="../../assets/images/search.svg"/></span>
          <input class="table-search-field w-full" type="text" [(ngModel)]="searchByClinician" [placeholder]="searchByClinicianPlaceHolder"
                 (keyup)="getEpisodes()" (ngModelChange)="clearSearchAndReload(searchByCaseManager)"/>
        </div>
      </ng-container>
    </div>
  </div>-->
  <div class="col-3">
    <div class="field">
      <label>Date</label>
      <div class="p-inputgroup table-calendar-wrapper">
        <span class="p-inputgroup-addon"><img src="assets/images/calendar.svg" alt="calendar.svg"/></span>
        <p-calendar class="w-full" dateFormat="{{datePickerFormat}}" placeholder="{{datePickerPlaceholder}}" [(ngModel)]="rangeDates" ngDefaultControl selectionMode="range" [readonlyInput]="true" inputId="range" (ngModelChange)="selectVisitDate()" (onClear)="onCalendarClear()"></p-calendar>
        <button *ngIf="rangeDates != null" (click)="onCalendarClear()" class="clearBtn">
          <img src="assets/images/error.svg" alt="">
        </button>
      </div>

    </div>
  </div>
</div>
<div class="table-wrapper">
  <div class="table-header">
    <div class="align-items-center flex">
      <div>
        <button pButton pRipple type="button" [disabled]="loading"
                class="p-button-text reload-btn" (click)="getEpisodes()">
        </button>
      </div>
      <h2>{{ patientSubmissionDropdown[0].label }}</h2>
      <div class="user-label">
        <img src="../../assets/images/episodesIcon.svg" alt="Episodes"/>
        <span>{{ totalEpisode }}</span>
      </div>
      </div>
  </div>
  <p-table #dt [value]="episodes" [(selection)]="selectedEpisodes" dataKey="id" styleClass="submison-patient-tbl">
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th id="patient">Patient</th>
        <th id="caseManagerSubmison" class="col-2">
          <div class="flex align-items-center gap-2">
            <span>Case Manager</span>
            <div class="filterClass">
              <img class="w-16" *ngIf="!selectedCaseManagerName || !selectedCaseManagerName.length"
                   (click)="dropdown.show()" src="assets/images/filter-outline.svg">
              <img class="w-18" *ngIf="selectedCaseManagerName && selectedCaseManagerName.length && selectedCaseManagerName.length > 0"
                   (click)="dropdown.show()" src="assets/images/filter-filled.svg">
              <p-multiSelect
                #dropdown
                (onPanelShow)="sortSelectedValues()"
                (onChange)="onSelectCaseManagerFilter()"
                [(ngModel)]="selectedCaseManagerName"
                [options]="caseManagerFilter"
                appendTo="body"
                optionLabel="label"
                optionValue="value"
                styleClass="typeMulitselect-dd"
              >
                <ng-template pTemplate="header"><span class="cursor-pointer clear-icon underline" (click)="clearSelectedValues(selectedCaseManagerName)"><img src="assets/images/filter-icn.svg" alt="exclamation.svg"></span></ng-template>
              </p-multiSelect>
            </div>
          </div>
        </th>
        <th id="startDate">Start Date</th>
        <th id="name">Name</th>
        <th id="visits">Visits</th>
        <th id="errors&Warnings">Errors & Warnings</th>
        <!--<th class="w-14rem">Intake Date</th>-->
        <!--<th class="w-10rem">No. of Days</th>-->
        <th id="status">Status</th>
        <th *ngIf="allowAdminRoles" id="adminRoles"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-episodes let-rowIndex="rowIndex">
      <tr class="p-selectable-row submission-open cursor-pointer" (click)="episodes.showSubmissionsDetails =! episodes.showSubmissionsDetails; onEpisodeRowClick(rowIndex)">
        <td>
          <span class="p-column-title">Patient</span>
          <div class="flex align-items-center gap-3">
            <!--<div class="gc-agency-img" *ngIf="episodes?.patient?.firstName">
              <app-avatar [firstName]="episodes.patient?.firstName" [lastName]="episodes.patient?.lastName"></app-avatar>
            </div>-->
            <div *ngIf="hidePatientName; else elseBlock">
              <p class="gc-agency-handle">{{ episodes.patient?._id | truncate: defaultPatientIdLength }}</p>
            </div>
            <ng-template #elseBlock>
              <div>
                <p class="gc-agency-name" *ngIf="episodes?.patient?.patientName">{{ (episodes.patient?.patientName) | truncate: defaultMrnLength | removeHtml }}</p>
                <p class="gc-agency-handle"> {{ (episodes.patient?.mrn ) | removeHtml | truncate: defaultMrnLength }}</p>
              </div>
              <div class="">
                <span tooltipStyleClass="eSocMRNToolTip" class="tooltip-icon" [escape]="false" pTooltip=
                      "<b>IOH ID:</b> {{episodes.patient?._id}}<br>
                      <b>MRN:</b> {{  episodes.patient?.mrn | removeHtml }}<br>
                      <b>Episode ID:</b> {{ episodes.episode?._id }}<br>
                      <b>Start Date:</b> {{ episodes.episode?.episodeCreatedAt | customDate }}<br>
                      <b>Number of Days:</b> {{ episodes.episode?.episodeCreatedAt | noOfDays }}">
                      <img src="assets/images/exclamation.svg" alt="exclamation.svg"></span>
              </div>
            </ng-template>
          </div>
        </td>
        <td>{{episodes?.patient?.caseManager | removeHtml}}</td>
        <td>
          <span class="p-column-title">Start Date</span>
          <span class="image-text">{{ episodes.episode?.episodeCreatedAt ? (currentUser.is_super_admin ? (episodes.episode?.episodeCreatedAt | customDate) : (episodes.episode?.episodeCreatedAt | date: dateFormat)) : '' }}</span>
        </td>
        <td>
          <span class="p-column-title">Episode Name</span>
          <div class="flex align-items-center gap-3">
            <div>
              <span class="image-text">{{ episodes.episode?.episodeName | removeHtml }}</span>
            </div>
<!--            <div class="">-->
<!--                <span tooltipStyleClass="episodeIDtooltip" class="tooltip-icon" [escape]="false"-->
<!--                      pTooltip="Episode ID: {{ episodes.episode?._id }}-->
<!--                      {{ episodes.episode?.numberOfDays ? 'Number of Days: ' + episodes.episode?.numberOfDays : '' }}-->
<!--                      " >-->
<!--                <img src="assets/images/exclamation.svg"></span>-->
<!--            </div>-->
          </div>
        </td>
        <td>
          <span class="p-column-title">No. of Visits</span>
          <span class="image-text">{{ episodes.episode?.totalCount}}</span>
        </td>
        <td>
          <span class="p-column-title">Errors & Warnings</span>
          <div *ngIf="episodes.episode?.totalAlertsErrors > 0 || episodes.episode?.totalAlertsWarnings > 0; else normalSection" class="flex gap-1">
            <div [class.errors-label]="episodes.episode?.totalAlertsErrors > 0" [class.success-label]="episodes.episode?.totalAlertsErrors === 0">{{ episodes.episode?.totalAlertsErrors }}</div>
            <div [class.success-label]="episodes.episode?.totalAlertsWarnings === 0" [class.warnings-label]="episodes.episode?.totalAlertsWarnings > 0">{{ episodes.episode?.totalAlertsWarnings }}</div>
          </div>
          <ng-template #normalSection>
          <div class="flex gap-1">
             <div [class.errors-label]="episodes.episode?.totalEpisodeErrors > 0" [class.success-label]="episodes.episode?.totalEpisodeErrors === 0">{{ episodes.episode?.totalEpisodeErrors }}</div>
            <div [class.success-label]="episodes.episode?.totalEpisodeWarnings === 0" [class.warnings-label]="episodes.episode?.totalEpisodeWarnings > 0">{{ episodes.episode?.totalEpisodeWarnings }}</div>
          </div>
          </ng-template>
        </td>
        <!--<td>
          <span class="p-column-title">Intake Date</span>
          <span class="image-text">{{ episodes.patient?.createdAt | customDate}}</span>
        </td>-->
        <!--<td>
          <span class="p-column-title">No. of Days</span>
          <span class="image-text">{{ episodes.episode?.numberOfDays }}</span>
        </td>-->
        <td>
          <span class="p-column-title">Status</span>
          <span class="image-text" [style.color]="submissionStatusColorEnum[statusColor(episodes.episode?.episodeStatus | lowercase)]">{{getLabelByValue(episodes.episode?.episodeStatus)}}</span>
        </td>
        <td *ngIf="allowAdminRoles">
          <span class="p-column-title">View</span>
          <mat-icon *ngIf="currentUser.is_super_admin">{{ episodes.showSubmissionsDetails ? "keyboard_arrow_up" : "keyboard_arrow_down" }}</mat-icon>
        </td>


      </tr>
      <ng-container *ngIf="episodes.showSubmissionsDetails">
        <ng-container [ngTemplateOutletContext]="{submissionDetails: episodes?.submissions, firstName: episodes.patient?.firstName,
        lastName: episodes.patient?.lastName, mrn:episodes.patient?.mrn, dob:episodes.patient?.dob, patientId: episodes.patient?._id,
                  totalErrorAndWarnings: episodes.patient?.totalErrors + episodes.patient?.totalWarnings, picture: episodes.patient?.picture, contactInfo: episodes?.patient?.contactInfo, icdCodes: episodes?.patient?.icdCodes}" [ngTemplateOutlet]="submissionListing">
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
                <span>
                  <em class="pi pi-exclamation-circle mr-2"></em>
                  No Episode found
                </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="paginator-wrapper">
    <p-paginator styleClass="gc-paginator" #paginator [rows]="noOfRecordPerRow" [totalRecords]="totalEpisode" (onPageChange)="paginate($event)" [rowsPerPageOptions]="rowsPerPageOptions"></p-paginator>
  </div>
</div>

<!-- Submission listing for open patient -->
<ng-template #submissionListing let-submissionDetails="submissionDetails" let-firstName="firstName" let-lastName="lastName" let-mrn="mrn" let-patientId="patientId" let-dob="dob" let-totalErrorAndWarnings="totalErrorAndWarnings" let-picture="picture", let-contactInfo="contactInfo", let-icdCodes="icdCodes">

  <tr class="cursor-pointer">
    <td colspan="10" class="leftBoder-4 p-0">
      <p-table #dt [value]="submissionDetails" class="submissionDetails-table">
        <ng-template pTemplate="header">
  <tr *ngIf="currentUser.is_super_admin">
    <th id="submittedBy">Submitted By</th>
    <th id="visitDate">Visit Date</th>
    <th id="visitType">Visit Type</th>
    <th id="lastDate">Last Date - Time</th>
    <th id="errorsAndWarnings">Errors & Warnings</th>
    <th id="status">Status</th>
    <ng-container *ngIf="allowAdminRoles">
      <th id="map">Map</th>
    </ng-container>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-selectedPatientSubmission let-rowIndex="rowIndex">
  <tr class="p-selectable-row sub-table-row"
      (click)="openPatientSubmissionDetails(selectedPatientSubmission,dob,mrn,firstName,lastName,totalErrorAndWarnings,picture, rowIndex, patientId, contactInfo, icdCodes)">
    <td>
      <span class="p-column-title">Submitted By</span>
      <div>
        <p class="gc-agency-name">{{ selectedPatientSubmission?.user?.firstName ? selectedPatientSubmission?.user?.firstName : ''}}
          {{ selectedPatientSubmission?.user?.lastName ? selectedPatientSubmission?.user?.lastName : '' | removeHtml}}
        </p>
        <p class="gc-agency-handle">{{ selectedPatientSubmission?.user?.defaultRole ? '(' + RoleEnum[selectedPatientSubmission?.user?.defaultRole] + ')' : ''   }}</p>
      </div>
    </td>
    <td>
      <span class="p-column-title">Visit Date</span>
      <span class="image-text">{{ selectedPatientSubmission?.visitDate | customDate: dateFormat }}</span>
    </td>
    <td>
      <span class="p-column-title">Visit Type</span>
      <span class="image-text">{{ selectedPatientSubmission?.visitType | removeHtml }}</span>
    </td>
    <td>
      <span class="p-column-title">Last Date - Time</span>
      <span class="image-text">{{selectedPatientSubmission?.submissionDate ?  (currentUser.is_super_admin ? (selectedPatientSubmission?.submissionDate | customDate) : (selectedPatientSubmission?.submissionDate | customDate: dateFormat)) : ''}}</span>
    </td>
    <td> <span class="p-column-title"></span></td>
    <td>
      <span class="p-column-title">Errors & Warnings</span>
      <div *ngIf="selectedPatientSubmission?.alertErrorCount > 0 || selectedPatientSubmission?.alertWarningCount > 0; else normalSection" class="flex gap-1">
        <div [class.errors-label]="selectedPatientSubmission?.alertErrorCount > 0" [class.success-label]="selectedPatientSubmission?.alertErrorCount === 0" >
          {{ selectedPatientSubmission?.alertErrorCount}}
        </div>
        <div [class.success-label]="selectedPatientSubmission?.alertWarningCount === 0" [class.warnings-label]="selectedPatientSubmission?.alertWarningCount > 0">
          {{ selectedPatientSubmission?.alertWarningCount }}
        </div>
      </div>
      <ng-template #normalSection>
        <div class="flex gap-1">
        <div [class.errors-label]="selectedPatientSubmission?.submissions?.submissionErrorCount > 0" [class.success-label]="selectedPatientSubmission?.submissions?.submissionErrorCount === 0" >{{ selectedPatientSubmission?.submissions?.submissionErrorCount}}</div>
        <div [class.success-label]="selectedPatientSubmission?.submissions?.submissionEWarningCount === 0" [class.warnings-label]="selectedPatientSubmission?.submissions?.submissionEWarningCount > 0">{{ selectedPatientSubmission?.submissions?.submissionEWarningCount }}</div>
      </div>
      </ng-template>
    </td>
    <td>
      <span class="p-column-title">Status</span>
      <span class="image-text" [style.color]="submissionStatusColorEnum[statusColor(selectedPatientSubmission?.status | lowercase)]">{{getLabelByValue(selectedPatientSubmission?.status)}}</span>
    </td>
    <ng-container *ngIf="allowAdminRoles">
      <td>
        <span class="p-column-title">Google Map</span>
        <div>
          <ng-container *ngIf="selectedPatientSubmission.latitude && selectedPatientSubmission.longitude; else notApplicableDiv">
            <div (click)="$event.stopPropagation(); patientSubmission = selectedPatientSubmission; showLocationDialog( selectedPatientSubmission.visitDate, selectedPatientSubmission.visitType)">
              <em class="pi pi-map-marker"></em>
            </div>
          </ng-container>
          <ng-template #notApplicableDiv>
            <div (click)="$event.stopPropagation()">Not Applicable</div>
          </ng-template>
        </div>
      </td>
    </ng-container>
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="8" style="text-align: center">
              <span>
                <em class="pi pi-exclamation-circle mr-2"></em>
                No Submission found
              </span>
    </td>
  </tr>
</ng-template>
</p-table>
</td>
</tr>
</ng-template>
<p-dialog [(visible)]="locationPopupDisplay" [modal]="true" [style]="{ width: '400px' }" [dismissableMask]="true">
  <ng-template pTemplate="header">
    <span>Visit Type: {{ selectedVisitType }} - Visit Date: {{ selectedVisitDates }}</span>
  </ng-template>
  <!-- <p-gmap [options]="options" *ngIf="locationPopupDisplay" [overlays]="overlays" [style]="{ 'width': '100%', 'height': '320px' }"></p-gmap> -->
  <!-- Google Maps component removed - GMapModule not available in PrimeNG 16+ -->
</p-dialog>
<p-sidebar
  class="sidebar-lg"
  position="right"
  [(visible)]="display"
  [showCloseIcon]="false"
  (onHide)="onSlideBarClose()">
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <div class="flex align-items-center gap-2">
        <h2 class="gc-form-heading">Visit Details</h2>
        <span>[{{ patientSubmission?.submissionDate ?  (patientSubmission?.submissionDate | customDate) : (patientSubmission?.submissionData?.submissionDate | customDate)}}]</span>
        <span [style.color]="visitDetailColors[patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status) ]">{{patientSubmission?.status ? getLabelByValue(patientSubmission?.status) : getLabelByValue(patientSubmission?.submissionData?.status) }}</span>
      </div>
      <div>
        <span (click)="onSlideBarClose()" class="cursor-pointer"><em class="pi pi-times"></em></span>
      </div>
    </div>
    <br />
    <br />
  </ng-template>
  <ng-template pTemplate="content">
    <app-visit-details [patientSubmission]="patientSubmission" (closeSideBar)="onSlideBarClose()" (eSOCUploadDisplay)="openeSOCUploadPopup()" (reloadPatientSubmission)="getEpisodes()"></app-visit-details>
  </ng-template>
</p-sidebar>
<app-esoc-upload *ngIf="eSOCUploadDisplay"
  [eSOCUploadDisplay]="eSOCUploadDisplay"
  [userId]="currentUser._id"
  [currentUserRole] = "currentUser.currentUserRole"
  [patientSubmission]="patientSubmission"
  (eSocPopUpClose)="eSOCUploadPopupClose()"
  (eSockUploadListingRefresh)="refreshListing()">
</app-esoc-upload>
